import "./AboutKTEXExpanded.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Mission from "./sections/Mission";
import Vision from "./sections/Vision";
import WhyKtex from "./sections/WhyKtex";
import Footer from "@/reusable_sections/Footer";
export default function AboutKTEXExpandedPage() {
  return <div>
      <Header />
      <Story />
      <Mission />
      <Vision />
      <WhyKtex />
      <Footer />
    </div>;
}